/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Broker
 */
export interface Broker {
    /**
     * 
     * @type {number}
     * @memberof Broker
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Broker
     */
    host?: string;
    /**
     * 
     * @type {number}
     * @memberof Broker
     */
    port?: number;
}

export function BrokerFromJSON(json: any): Broker {
    return BrokerFromJSONTyped(json, false);
}

export function BrokerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Broker {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'host': !exists(json, 'host') ? undefined : json['host'],
        'port': !exists(json, 'port') ? undefined : json['port'],
    };
}

export function BrokerToJSON(value?: Broker | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'host': value.host,
        'port': value.port,
    };
}

